var ObjectUtils = require('../../util/object_utils');
module.exports = ObjectUtils.merge(
    require('./screen_messages.json'),
    require('./errors.json')
);



// WEBPACK FOOTER //
// ./src/dict/ar/ar.js